import { MaxBrainLocation } from 'app/library/location/models/location.model';
import { ILandingPageComponentListingEventPreviewQuery } from '../interfaces/landing-page-component-listing-event-preview.query.interface';
import * as momentImported from 'moment';

const moment = momentImported;

export class LandingPageComponentListingEventPreview {
    id: string;
    name: string;
    start: Date;
    end: Date | null;
    location: MaxBrainLocation | null;
    listingScheduleDateLabel: string | null = null;
    listingScheduleTimeLabel: string | null = null;

    constructor(query: ILandingPageComponentListingEventPreviewQuery) {
        this.id = query.id.toString();
        this.name = query.name;
        this.start = new Date(query.start);
        this.end = query.end ? new Date(query.end) : null;
        this.location = query.location ? new MaxBrainLocation(query.location) : null;
    }

    applyListingScheduleLabels(locale: string): void {
        const start = moment(this.start).locale(locale);
        const startDateLabel = start.format('ddd D MMM');

        if (!this.end) {
            this.listingScheduleDateLabel = startDateLabel;
            this.listingScheduleTimeLabel = start.format('HH:mm');
            return;
        }

        const end = moment(this.end).locale(locale);
        const endDateLabel = end.format('ddd D MMM');

        this.listingScheduleDateLabel = end.isSame(start, 'day') ? startDateLabel : `${startDateLabel} - ${endDateLabel}`;
        this.listingScheduleTimeLabel = `${start.format('HH:mm')} - ${end.format('HH:mm')}`;
    }
}
